import { render, staticRenderFns } from "./addAServTypeMenu.vue?vue&type=template&id=1d3e7adc"
import script from "./addAServTypeMenu.vue?vue&type=script&lang=js"
export * from "./addAServTypeMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports